/* jshint maxcomplexity: 5, maxparams: 3, maxdepth: 2, maxstatements: 10 */

'use strict';
var searchPartMixin = require('../modules/mixins/searchpart.mixin');

Odigeo.defineWidget('flexible_dates_search_manager', Odigeo.Widget.extend({

    modelClass: Odigeo.Model.extend(searchPartMixin.extend({
        defaults: {
            flexibleDates: false,
        },

        bindCustomEvents: function(searchModel) {
            this.searchModel = searchModel;
        },
    })),
    viewClass: Odigeo.View.extend({
        events: {
            'change input[type=checkbox]': 'onChange',
        },

        selectors: {
            input: '.calendar_grid_selector_input',
            wrapper: '.calendar_grid_selector_wrapper',
        },

        init: function() {
            this.listenTo(this.model, 'sync:fetch', this.render);
            this.listenTo(this.model.searchModel, 'change:type', this.render);
            this.render();
        },

        render: function() {
            var isVisible = this.model.searchModel.get('type') === 'oneWayTrip';
            this.$cachedSelectors.wrapper.toggleClass('odf-hidden', !isVisible);
            this.$cachedSelectors.input.prop('checked', this.model.get('flexibleDates'));
            return this;
        },

        onChange: function(event) {
            this.model.save({'flexibleDates': event.currentTarget.checked});
        },
    }),
}));
